import { cx } from "../tv";

/** Shapes that match the final layout; shown only after 150 ms by the caller (useDelayed). No spinners in content. */
export function Skeleton({ className, rounded = "md" }: { className?: string; rounded?: "md" | "pill" | "lg" }) {
  return (
    <span
      aria-hidden
      data-skeleton=""
      className={cx(
        "block bg-[linear-gradient(90deg,var(--surface-2)_0%,var(--hover)_50%,var(--surface-2)_100%)] bg-[length:200%_100%] animate-[os-shimmer_1.6s_linear_infinite]",
        rounded === "md" && "rounded-sm",
        rounded === "pill" && "rounded-pill",
        rounded === "lg" && "rounded-xl",
        className,
      )}
    />
  );
}

export function SkeletonRows({ rows = 6, className }: { rows?: number; className?: string }) {
  return (
    <div className={cx("flex flex-col", className)} aria-busy="true" data-state="loading">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex h-(--row-h) items-center gap-3 border-t border-row-line px-4 first:border-t-0">
          <Skeleton className="size-4" rounded="pill" />
          <Skeleton className="h-3" />
          <span className="flex-1" />
          <Skeleton className="h-3 w-16" />
          <Skeleton className="size-[22px]" rounded="pill" />
          <Skeleton className="h-3 w-10" />
        </div>
      ))}
    </div>
  );
}
